import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import {
  Charsets_getInstanceqkyjyusuh1b0 as Charsets_getInstance,
  get_name2f11g4r0d5pxp as get_name,
} from '../../../../../ktor-ktor-io/io/ktor/utils/io/charsets/Charset.js.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { PipelineContext34fsb0mycu471 as PipelineContext } from '../../../../../ktor-ktor-utils/io/ktor/util/pipeline/PipelineContext.mjs';
import { Phases_getInstance1n7sbxr3lcpvf as Phases_getInstance } from '../request/HttpRequestPipeline.mjs';
import {
  isSuspendFunction153vlp5l2npj9 as isSuspendFunction,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { toList2zksu85ukrmi as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Maps.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Collection1k04j3hzsbod0 as Collection } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  Text_getInstancereo9eglzqyxz as Text_getInstance,
  charset1dribv3ku48b1 as charset,
  withCharset27k3t3dvzhi4n as withCharset,
} from '../../../../../ktor-ktor-http/io/ktor/http/ContentTypes.mjs';
import { TextContent1rb6ftlpvl1d2 as TextContent } from '../../../../../ktor-ktor-http/io/ktor/http/content/TextContent.mjs';
import {
  charset3qqtyytkmxogi as charset_0,
  contentType2zzm38yxo3syt as contentType,
} from '../../../../../ktor-ktor-http/io/ktor/http/HttpMessageProperties.mjs';
import { readText27783kyxjxi1g as readText } from '../../../../../ktor-ktor-io/io/ktor/utils/io/core/Strings.mjs';
import { HttpRequestBuilder15f2nnx9sjuv1 as HttpRequestBuilder } from '../request/HttpRequest.mjs';
import { PrimitiveClasses_getInstanceds06xwqrwfdm as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { readRemaining1u8soafhjma7y as readRemaining } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannelOperations.mjs';
import { TransformResponseBodyContext1axf7xx6ifwbj as TransformResponseBodyContext } from './api/KtorCallContexts.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { KtorSimpleLogger1xdphsp5l4e48 as KtorSimpleLogger } from '../../../../../ktor-ktor-utils/io/ktor/util/logging/KtorSimpleLogger.web.mjs';
import { createClientPluginjwpvufjows5r as createClientPlugin } from './api/CreatePluginUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_LOGGER() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return LOGGER;
}
var LOGGER;
function get_HttpPlainText() {
  _init_properties_HttpPlainText_kt__iy89z1();
  return HttpPlainText;
}
var HttpPlainText;
var HttpPlainTextConfigClass;
function HttpPlainTextConfig() {
  if (HttpPlainTextConfigClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableSetOf' call
        tmp.z5p_1 = LinkedHashSet().s2();
        var tmp_0 = this;
        // Inline function 'kotlin.collections.mutableMapOf' call
        tmp_0.a5q_1 = LinkedHashMap().bc();
        this.b5q_1 = null;
        this.c5q_1 = Charsets_getInstance().j4l_1;
      }
    }
    initMetadataForClass($, 'HttpPlainTextConfig', HttpPlainTextConfig);
    HttpPlainTextConfigClass = $;
  }
  return HttpPlainTextConfigClass;
}
var RenderRequestHook$install$slambdaClass;
function RenderRequestHook$install$slambda() {
  if (RenderRequestHook$install$slambdaClass === VOID) {
    class $ {
      constructor($handler) {
        this.d5q_1 = $handler;
      }
      *r5f($this$intercept, content, $completion) {
        var result = yield* this.d5q_1($this$intercept.g4r_1, content, $completion);
        if (!(result == null)) {
          yield* $this$intercept.i4q(result, $completion);
        }
        return Unit_instance;
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof PipelineContext() ? p1 : THROW_CCE();
        return this.r5f(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    RenderRequestHook$install$slambdaClass = $;
  }
  return RenderRequestHook$install$slambdaClass;
}
function RenderRequestHook$install$slambda_0($handler) {
  var i = new (RenderRequestHook$install$slambda())($handler);
  var l = ($this$intercept, content, $completion) => i.r5f($this$intercept, content, $completion);
  l.$arity = 2;
  return l;
}
var RenderRequestHookClass;
function RenderRequestHook() {
  if (RenderRequestHookClass === VOID) {
    class $ {
      e5q(client, handler) {
        var tmp = Phases_getInstance().l5m_1;
        client.y5f_1.k4r(tmp, RenderRequestHook$install$slambda_0(handler));
      }
      n5m(client, handler) {
        return this.e5q(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
      }
    }
    initMetadataForObject($, 'RenderRequestHook');
    RenderRequestHookClass = $;
  }
  return RenderRequestHookClass;
}
var RenderRequestHook_instance;
function RenderRequestHook_getInstance() {
  return RenderRequestHook_instance;
}
function HttpPlainTextConfig$_init_$ref_isjudo() {
  var l = () => new (HttpPlainTextConfig())();
  l.callableName = '<init>';
  return l;
}
function HttpPlainText$lambda($this$createClientPlugin) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.collections.sortedByDescending' call
  var this_0 = toList($this$createClientPlugin.w5m_1.a5q_1);
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp = HttpPlainText$lambda$lambda;
  var tmp$ret$1 = new (sam$kotlin_Comparator$0())(tmp);
  var withQuality = sortedWith(this_0, tmp$ret$1);
  var responseCharsetFallback = $this$createClientPlugin.w5m_1.c5q_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this$createClientPlugin.w5m_1.z5p_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().p2();
  var _iterator__ex2g4s = tmp0.p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    if (!$this$createClientPlugin.w5m_1.a5q_1.s4(element)) {
      destination.i2(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = HttpPlainText$lambda$lambda_0;
  var tmp$ret$6 = new (sam$kotlin_Comparator$0())(tmp_0);
  var withoutQuality = sortedWith(destination, tmp$ret$6);
  var tmp_1;
  var tmp0_0 = $this$createClientPlugin.w5m_1.z5p_1;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp_2;
    if (isInterface(tmp0_0, Collection())) {
      tmp_2 = tmp0_0.n1();
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp$ret$7 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = tmp0_0.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var element_0 = _iterator__ex2g4s_0.r1();
      if (!element_0.equals(Charsets_getInstance().j4l_1)) {
        tmp$ret$7 = true;
        break $l$block_0;
      }
    }
    tmp$ret$7 = false;
  }
  if (tmp$ret$7) {
    tmp_1 = true;
  } else {
    var tmp0_1 = $this$createClientPlugin.w5m_1.a5q_1.v4();
    var tmp$ret$9;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_3;
      if (isInterface(tmp0_1, Collection())) {
        tmp_3 = tmp0_1.n1();
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp$ret$9 = false;
        break $l$block_2;
      }
      var _iterator__ex2g4s_1 = tmp0_1.p1();
      while (_iterator__ex2g4s_1.q1()) {
        var element_1 = _iterator__ex2g4s_1.r1();
        if (!element_1.equals(Charsets_getInstance().j4l_1)) {
          tmp$ret$9 = true;
          break $l$block_2;
        }
      }
      tmp$ret$9 = false;
    }
    tmp_1 = tmp$ret$9;
  }
  var hasRegisteredCharsets = tmp_1;
  var tmp_4;
  if (hasRegisteredCharsets) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_1 = StringBuilder().l1();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = withoutQuality.p1();
    while (_iterator__ex2g4s_2.q1()) {
      var element_2 = _iterator__ex2g4s_2.r1();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      this_1.m1(get_name(element_2));
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = withQuality.p1();
    while (_iterator__ex2g4s_3.q1()) {
      var element_3 = _iterator__ex2g4s_3.r1();
      var charset = element_3.we();
      var quality = element_3.xe();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(this_1) > 0) {
        this_1.m1(',');
      }
      // Inline function 'kotlin.check' call
      if (!(0.0 <= quality ? quality <= 1.0 : false)) {
        throw IllegalStateException().o('Check failed.');
      }
      // Inline function 'kotlin.math.roundToInt' call
      var this_2 = 100 * quality;
      var truncatedQuality = roundToInt(this_2) / 100.0;
      this_1.m1(get_name(charset) + ';q=' + truncatedQuality);
    }
    tmp_4 = this_1.toString();
  } else {
    tmp_4 = null;
  }
  var acceptCharsetHeader = tmp_4;
  var tmp0_elvis_lhs = $this$createClientPlugin.w5m_1.b5q_1;
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
  var tmp_5;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = firstOrNull(withQuality);
    tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.ue_1;
  } else {
    tmp_5 = tmp1_elvis_lhs;
  }
  var tmp3_elvis_lhs = tmp_5;
  var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().j4l_1 : tmp3_elvis_lhs;
  var tmp_6 = RenderRequestHook_instance;
  $this$createClientPlugin.z5m(tmp_6, HttpPlainText$lambda$slambda_0(acceptCharsetHeader, requestCharset));
  $this$createClientPlugin.f5q(HttpPlainText$lambda$slambda_2(responseCharsetFallback));
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.g5q_1 = function_0;
      }
      eh(a, b) {
        return this.g5q_1(a, b);
      }
      compare(a, b) {
        return this.eh(a, b);
      }
      i5() {
        return this.g5q_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i5(), other.i5());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i5());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function HttpPlainText$lambda$lambda(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.ve_1;
  var tmp$ret$2 = a.ve_1;
  return compareValues(tmp, tmp$ret$2);
}
function HttpPlainText$lambda$lambda_0(a, b) {
  _init_properties_HttpPlainText_kt__iy89z1();
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = get_name(a);
  var tmp$ret$2 = get_name(b);
  return compareValues(tmp, tmp$ret$2);
}
function invoke$wrapContent(requestCharset, request, content, requestContentType) {
  var contentType = requestContentType == null ? Text_getInstance().t4u_1 : requestContentType;
  var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
  var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
  get_LOGGER().k4s('Sending request body to ' + request.p5h_1.toString() + ' as text/plain with charset ' + charset_0.toString());
  return new (TextContent())(content, withCharset(contentType, charset_0));
}
function invoke$read(responseCharsetFallback, call, body) {
  var tmp0_elvis_lhs = charset_0(call.l5g());
  var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
  get_LOGGER().k4s('Reading response body for ' + call.g5i().p5i().toString() + ' as String with charset ' + actualCharset.toString());
  return readText(body, actualCharset);
}
function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
  if (value == null || !(_this__u8e3s4.r5h_1.m2o('Accept-Charset') == null))
    return Unit_instance;
  get_LOGGER().k4s('Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.p5h_1.toString());
  _this__u8e3s4.r5h_1.k4o('Accept-Charset', value);
}
var HttpPlainText$lambda$slambdaClass;
function HttpPlainText$lambda$slambda() {
  if (HttpPlainText$lambda$slambdaClass === VOID) {
    class $ {
      constructor($acceptCharsetHeader, $requestCharset) {
        this.h5q_1 = $acceptCharsetHeader;
        this.i5q_1 = $requestCharset;
      }
      *j5q(request, content, $completion) {
        invoke$addAcceptCharsetHeader(request, this.h5q_1);
        if (!(typeof content === 'string'))
          return null;
        var contentType_0 = contentType(request);
        if (!(contentType_0 == null) && !(contentType_0.a4t_1 === Text_getInstance().t4u_1.a4t_1)) {
          return null;
        }
        return invoke$wrapContent(this.i5q_1, request, content, contentType_0);
      }
      md(p1, p2, $completion) {
        var tmp = p1 instanceof HttpRequestBuilder() ? p1 : THROW_CCE();
        return this.j5q(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    HttpPlainText$lambda$slambdaClass = $;
  }
  return HttpPlainText$lambda$slambdaClass;
}
function HttpPlainText$lambda$slambda_0($acceptCharsetHeader, $requestCharset) {
  var i = new (HttpPlainText$lambda$slambda())($acceptCharsetHeader, $requestCharset);
  var l = (request, content, $completion) => i.j5q(request, content, $completion);
  l.$arity = 2;
  return l;
}
var HttpPlainText$lambda$slambdaClass_0;
function HttpPlainText$lambda$slambda_1() {
  if (HttpPlainText$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor($responseCharsetFallback) {
        this.k5q_1 = $responseCharsetFallback;
      }
      *l5q($this$transformResponseBody, response, content, requestedType, $completion) {
        if (!requestedType.y4r_1.equals(PrimitiveClasses_getInstance().zf()))
          return null;
        var bodyBytes = yield* readRemaining(content, $completion);
        return invoke$read(this.k5q_1, response.n5i(), bodyBytes);
      }
      m5q(p1, p2, p3, p4, $completion) {
        var tmp = p1 instanceof TransformResponseBodyContext() ? p1 : THROW_CCE();
        var tmp_0 = p2 instanceof HttpResponse() ? p2 : THROW_CCE();
        var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel()) : false) ? p3 : THROW_CCE();
        return this.l5q(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo() ? p4 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [4]);
    HttpPlainText$lambda$slambdaClass_0 = $;
  }
  return HttpPlainText$lambda$slambdaClass_0;
}
function HttpPlainText$lambda$slambda_2($responseCharsetFallback) {
  var i = new (HttpPlainText$lambda$slambda_1())($responseCharsetFallback);
  var l = ($this$transformResponseBody, response, content, requestedType, $completion) => i.l5q($this$transformResponseBody, response, content, requestedType, $completion);
  l.$arity = 4;
  return l;
}
var properties_initialized_HttpPlainText_kt_2nx4ox;
function _init_properties_HttpPlainText_kt__iy89z1() {
  if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
    properties_initialized_HttpPlainText_kt_2nx4ox = true;
    LOGGER = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
    var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
    HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
  }
}
//region block: init
RenderRequestHook_instance = new (RenderRequestHook())();
//endregion
//region block: exports
export {
  get_HttpPlainText as get_HttpPlainText2hd9sygnz4kij,
};
//endregion

//# sourceMappingURL=HttpPlainText.mjs.map
